import React, { useEffect } from "react"

const GoogleAd = ({ slot }) => {
  useEffect(() => {
    try {
      const adsbygoogle = window.adsbygoogle || []
      adsbygoogle.push({})
    } catch (e) {
      console.error(e)
    }
  }, [])
  
  return (
    <ins 
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-4528415803965338"
      data-ad-slot={slot}
      data-ad-format="horizontal,auto"
      data-full-width-responsive="true">
    </ins>
  )
}

export default GoogleAd;
